export class UserList {

	userName: string;
	userCpf: number;
	userEditable: boolean;

	constructor() {

	}
}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/user-admin/models/user-list.ts